import logo from '../assets/images/favicon.ico'
// import video from '../assets/images/logoVideo.mp4'
const Logo = () => {
  return (
   <img src={logo} alt='fuzz tv' className='logo' />
  // <video src={video} width="750" height="500" controls>
  //    </video>
  )
}

export default Logo
